/**
 * Git and Branch Constants
 * 
 * Centralized constants for Git-related operations
 */

// Default branch names
export const DEFAULT_MICROSERVICE_BRANCH = 'master'; // Default branch for microservice repositories
export const DEFAULT_PROJECT_BRANCH = 'main';         // Default branch for Mia Platform project configuration

// Export as default object for convenience
export default {
  DEFAULT_MICROSERVICE_BRANCH,
  DEFAULT_PROJECT_BRANCH
};
